<template>
  <v-data-table
    :headers="data.content.headers"
    :items="data.content.desserts"
    class="elevation-0"
  ></v-data-table>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Table',

  props: ['data', 'hoverColor', 'modifyMode', 'editedAuth'],

  data() {
    return {}
  },

  methods: {
    ...mapActions('document', ['setCreateMode'])
  }
}
</script>

<style lang="scss" scoped>
</style>
